<template>
  <v-list-item-title class="text-center">
    <strong>PCM Soluções</strong>
    {{ !getClientName ? null : ` | ${getClientName}` }}
  </v-list-item-title>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import loginStore from '../modules/login/_store'
export default {
  computed: {
    ...mapGetters('getClientNameStore', ['getClientName']),
  },

  async created() {
    registerVuexModule(this.$store, 'getClientNameStore', loginStore)

    if (!this.getClientName) {
      await this.obterNomeDoCliente()
    }
  },

  methods: {
    ...mapActions('getClientNameStore', ['obterNomeDoCliente']),
  },
}
</script>
